type UnregisterFn = () => Promise<void>;

interface FcmUnregisterEntry {
  unregister: UnregisterFn;
  revokeLocal: UnregisterFn;
}

const unregisterEntries: FcmUnregisterEntry[] = [];

export function setFcmUnregister(fn: UnregisterFn | null, revokeLocal?: UnregisterFn): void {
  if (!fn) {
    unregisterEntries.length = 0;
    return;
  }
  if (!unregisterEntries.some((entry) => entry.unregister === fn)) {
    unregisterEntries.push({ unregister: fn, revokeLocal: revokeLocal ?? fn });
  }
}

export function removeFcmUnregister(fn: UnregisterFn): void {
  const index = unregisterEntries.map((entry) => entry.unregister).lastIndexOf(fn);
  if (index >= 0) {
    unregisterEntries.splice(index, 1);
  }
}

/**
 * Every mounted consumer gets its callback run: `useFcmToken` is instantiated by more than one
 * component, and draining only the last registration left the others believing they were still
 * subscribed. Clearing before awaiting keeps a concurrent second call from running them twice.
 */
async function runOnEntries(pick: (entry: FcmUnregisterEntry) => UnregisterFn, drain: boolean): Promise<void> {
  const entries = drain ? unregisterEntries.splice(0) : [...unregisterEntries];
  await Promise.allSettled(entries.map((entry) => pick(entry)()));
}

export async function unregisterFcmOnLogout(): Promise<void> {
  await runOnEntries((entry) => entry.unregister, true);
}

export async function revokeFcmOnForcedSignOut(): Promise<void> {
  await runOnEntries((entry) => entry.revokeLocal, true);
}

export async function unregisterCurrentFcmToken(): Promise<void> {
  await runOnEntries((entry) => entry.unregister, false);
}
